


const Onboarding = () => {



    return (
        <iframe
            src="https://onboarding-crm.onrender.com/login"
            title="Onboarding"
            width={"100%"}
            style={{border: "none"}}
        />
    )
}

export default Onboarding;